import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import React from "react";
import {useTheme} from "../contexts/theme";
import {SportImagesDict} from "../utils/constants"
import LoginForm from "../components/LoginContent/LoginForm";
import {SupportedSports} from "../types/generic";

const Login= () => {

    const theme  = useTheme();

    return (
        <Box
            style={{
                width: "100vw",
                height: "100vh",
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                backgroundColor: theme.palette.blue
            }}
        >
            <Grid container direction="column"  style={{ height: '100%'}}>

                {/* Main Content */}
                <Grid item xs={12} sm={7} md={5} lg={12} style={{
                    padding: theme.spacing.none,
                    flex: 1,
                    color: "white",
                    backgroundImage: `url(${SportImagesDict.Login[process.env.REACT_APP_SPORT as SupportedSports]})`,

                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                }}>
                        <LoginForm />
                </Grid>

            </Grid>
        </Box>
    );

}

export default Login;